(function () {
        'use strict';

        /**
         * @ngdoc service
         * @name trainingPrograms.service:trainingProgramsService
         *
         * @description
         *
         */
        angular
            .module('trainingPrograms')
            .service('TrainingProgramsService', TrainingProgramsService);
        function TrainingProgramsService(RemoteService, applicationConstants, CommonLogicService) {
            var self = this,
                view="TRAINING_PROGRAMS",
                trainingLocation = [{
                    airPortCode:null,
                    airPortName:"ANY "
                }],
                newAirCraftTypes = [],
                trainingCategories = [],
                TrainingPrograms = [],
                appliedFilters = {},
                localFilters= {
                    trainingLocation:{
                        filterName:'trainingLocationName',
                        keysMap:[{
                            key:'airPortName',
                            keyMap: 'trainingLocationName'
                        },{
                            key:'airPortCode',
                            keyMap:'trainingLocationName'
                        }],
                        list:[]
                    },
                    trainingCategory:{
                        filterName: 'trainingProCategory',
                        keysMap:[
                            {
                                key:'category',
                                keyMap: 'trainingProCategory'
                            },{
                                key:'categoryCode',
                                keyMap:'trainingProCategory'
                            }],
                        list:[]
                    },
                    airCraftType:{
                        filterName: 'flightModelNumber',
                        keysMap:[{
                            key:'model',
                            keyMap: 'flightModelNumber'
                        },{
                            key:'modelNumber',
                            keyMap:'flightModelNumber'
                        }],
                        list:[]
                    }
                };
            self.model = {
                searchCriteria:null,
                viewUpdateSearchCriteria:null,
                selectedTrainingForSave:null,
                conflictsTrainings:null
            };

            /**
             * TrainingProgramRequest DTO
             * @constructor
             */
            function TrainingProgramRequest(){
                this.fromDate = null;
                this.toDate = null;
                this.trainingLocation=null;
                this.trainingProgCategory = null;
                this.aircraftModel=null;
                this.pageSize=0;
                this.startPosition=0;
            }

            function DeleteTrainingSlotDTO() {
                this.trainingSlotId=0;
                this.version=0;
            }

            function ReSyncTrainingSlotDTO() {
                this.trainingSlotId=0;
                this.trainingProgCategory=null;
                this.trainingProgramCode =null;
                this.version=0;
            }

            function SubProgram() {
                this.slotProgramCode=null;
                this.subProgramCode=null;
                this.subProgramDesc=null;
            }

            function TrainingProgram() {
                this.endDate=null;
                this.endTime=null;
                this.flightModelNumber=null;
                this.flyingHrsReq=null;
                this.selectedTrainingProDetailID=null;
                this.selectedTrainingProID=null;
                this.slotName=null;
                this.startDate=null;
                this.startTime=null;
                this.subProgramDetails=null;
                this.subPrograms=[new SubProgram()];
                this.timeValue=null;
                this.trainingLocationCode=null;
                this.trainingLocationName=null;
                this.trainingProCategory=null;
                this.trainingProgStatusDesc=null;
                this.trainingProgramDesc=null;
                this.trainingProgramStatusCode=null;
                this.trainingSlotID=null;
                this.trainingStationCode=null;
                this.trainingStationName=null;
                this.version=null;
                this.hotelCost=null;
                this.costType=null;
            }

            /**
             * get the view name
             * @returns {string}
             */
            self.getViewName = function(){
                return view;
            };

            self.getLocalFilters = function (filterPass) {
                var locFilter = localFilters[filterPass.filterKey];
                appliedFilters[locFilter['filterName']] = $.trim(filterPass.filterValue[filterPass.filterField]);
                return appliedFilters;
            };

            /**
             * get training locations
             * @returns {*[]}
             */
            self.getFilterTrainingLocations = function(){
                 return localFilters.trainingLocation.list;
            };

            self.getFilterTrainingCategories = function(){
                return localFilters.trainingCategory.list;
            };

            self.getFilterAircraftModels = function(){
                return localFilters.airCraftType.list;
            };

            self.getDefaultTrainingLocation = function () {
                trainingLocation = [];
                trainingLocation.push({
                    airPortCode:null,
                    airPortName:"ANY "
                });
                return trainingLocation[0];
            };

            self.getTrainingsPrograms = function () {
                return TrainingPrograms;
            };

            self.filterTrainingLocally = function (filter) {
                return applyLocalFilter(filter);
            };

            self.getTrainingsProgramsForSearchCriteria = function (range) {
                return getProgramsByStartDate(range);
            };

            self.setTrainingPrograms = function (trainingPrograms) {
                TrainingPrograms = trainingPrograms;
                applyLocalFilters();
            };

            self.setAndUpdateTrainingPrograms = function (trainingPrograms) {
                TrainingPrograms = trainingPrograms;
                applyLocalFilters();
            };

            self.getNewTraining=function () {
                return new TrainingProgram();
            };

            self.setSelectedTrainingForSave = function (selectedTraining) {
                self.model.selectedTrainingForSave = selectedTraining;
            };

            self.getSelectedTrainingForSave = function () {
                return self.model.selectedTrainingForSave;
            };

            self.setConflictsTrainingPrograms = function (conflictsTrainings) {
                self.model.conflictsTrainings = setStartDateTimeForConflicts(conflictsTrainings);
            };

            self.getConflictsTrainingPrograms = function () {
                return self.model.conflictsTrainings;
            };

            self.setAirCraftTypes = function (airCraftTypes) {
                newAirCraftTypes = [];
                var airCraftTypeAny = {model: "ANY",modelNumber : "ANY"};
                newAirCraftTypes.push(airCraftTypeAny);
                angular.forEach(airCraftTypes, function (airCraftType) {
                    newAirCraftTypes.push({model: airCraftType.airCraftType + " ",modelNumber : airCraftType.airCraftType + " ",
                    	airCraftType : airCraftType.airCraftType + " "});
                });
                return newAirCraftTypes;
            };

            self.getDefaultTrainingCategory = function () {
                return localFilters.trainingCategory.list[0];
            };

            self.getDefaultAircraftType = function () {
                return localFilters.airCraftType.list[0];
            };
            /**
             * load training categories
             * @returns {*[]}
             */
            self.getTrainingCategories = function(successFn, errorFn){
                RemoteService.loadTrainingCategories().then(function(response){
                        if (response.success && response.hasOwnProperty('trainingCategoryList')){
                            successFn(formatCategories(response.trainingCategoryList));
                        }
                    },
                    function(error){
                        errorFn(error.msg[0]);
                    });
            };

            self.setTrainingSearchCriteria = function(criteriaModel){
                self.model.searchCriteria = criteriaModel;
            };

            self.getTrainingSearchCriteria = function(){
                return formatSearchCriteria(self.model.searchCriteria)
            };

            self.setViewUpdateSearchCriteria = function(criteriaModel){
                self.model.viewUpdateSearchCriteria = criteriaModel;
            };

            self.getViewUpdateSearchCriteria = function(){
                return self.model.viewUpdateSearchCriteria;
            };

            self.getViewType = function(){
                return getViewDaysBySearchCriteria('V');
            };

            self.searchTrainingPrograms = function(params, successFn, errorFn){
                //var searchCriteria = ;
                RemoteService.searchTrainingPrograms(params).then(function(response){
                    if (response.success && response.trainingSlotCollection){
                        successFn(response.trainingSlotCollection);
                    }
                },
                function(error){
                    errorFn(error.msg[0]);
                });
            };

            self.compareSearchCriteriaWithSavedProgram = function (saveRequest) {
                var saveSearchCriteria = new TrainingProgramRequest();
                saveSearchCriteria.fromDate = saveRequest.fromDate;
                saveSearchCriteria.toDate = saveRequest.toDate;
                saveSearchCriteria.aircraftModel = saveRequest.aircraftModelNo;
                saveSearchCriteria.trainingProgCategory = saveRequest.trainingProgCategory;
                saveSearchCriteria.trainingLocation = saveRequest.trainingLocation;
                saveSearchCriteria.pageSize=-1;
                saveSearchCriteria.startPosition=1;
                return getCompairedStatus(saveSearchCriteria);
            };

            self.getTrainingStatusMap = function(){
                var sendArray = [];
                angular.forEach(applicationConstants.TRAINING_STATUS, function(value,key){
                    var temp = {
                        icon: getIconByStatus(key),
                        text: value,
                        status:key
                    };
                    sendArray.push(temp);
                });
                return sendArray;
            };

            self.getTraProgramsToolbarConfigs = function (view) {
                return trainingProgramButtonConfig(view);
            };

            self.getDateRangeWithOffset = function (viewType, nextPrevFlag, offset) {
                return getDateRangeWithOffset(viewType, nextPrevFlag, offset);
            };

            self.getNoOfDaysByView = function (view, stDate) {
                return getNoOfDaysByView(view, stDate);
            };

            self.getAvailabilityOfDataNewSearchParams = function (range) {
                return checkResultsForRange(range);
            };

            self.saveTrainingProgram = function (successFn, errorFn) {
                var selectedProgram = self.model.selectedTrainingForSave;
                RemoteService.saveTrainingPrograms(selectedProgram).then(function(response){
                    successFn(response);
                },
                function(error){
                    if(error.msg===undefined){
                        error.msg[0] = "Service Error";
                    }
                    errorFn(error.msg[0]);
                });
            };

            self.deleteTrainingPrograms = function (selectedPrograms, successFn, errorFn) {
                RemoteService.deleteTrainingPrograms(selectedPrograms).then(
                    function(response){
                        successFn(response);
                    },
                    function(error){
                        errorFn(error);
                    }
                );
            };

            self.reSyncTrainingPrograms = function (trainingProgram, successFn, errorFn) {
                RemoteService.reSyncOtherHubTrainings(trainingProgram).then(
                    function(response){
                        successFn(response);
                    },
                    function(error){
                        errorFn(error);
                    }
                );
            };

            self.getProcessedSelectedTrainings = function (List, selectedItem) {
                var _index = CommonLogicService.getIndexInList(List, selectedItem, 'trainingSlotID');
                if (_index>-1){
                    List.splice(_index,1);
                }else{
                    List.push(selectedItem);
                }
                return List
            };

            self.resetSelectedTrainingPrograms = function (List) {
                _.each(List, function (item) {
                    item.selectedFlag=false;
                });
            };

            self.getTrainingToDelete = function (List) {
                var listOfTraining = [], deleteRq = {};
                angular.forEach(List, function (object) {
                    var deleteTraining = new DeleteTrainingSlotDTO();
                    deleteTraining.trainingSlotId = object.trainingSlotID;
                    deleteTraining.version = object.version;
                    listOfTraining.push(deleteTraining);
                });
                deleteRq.deleteTrainingSlotList = listOfTraining;
                return deleteRq;
            };

            self.getTrainingToReSync = function (List) {
                var listOfTraining = [], reSyncRq = {};
                angular.forEach(List, function (object) {
                    var reSyncTraining = new ReSyncTrainingSlotDTO();
                    reSyncTraining.trainingSlotId = object.trainingSlotID;
                    reSyncTraining.trainingProgCategory = $.trim(object.trainingProgramObject.categoryCode);
                    if(object.programDetailsObject != null){
                      reSyncTraining.trainingProgramCode = object.programDetailsObject.trainingProgCode;
                    }
                    reSyncTraining.version = object.version;
                    listOfTraining.push(reSyncTraining);
                });
                reSyncRq.reSyncTrainingSlotList = listOfTraining;
                return reSyncRq;
            };

            function getIconByStatus(status){
                var st = "check_circle";
                if(status==="TENTATIVE"){
                    st = "error";
                }else if(status==="CANCELLED"){
                    st = "block";
                }
                return st;
            }

            function getColorByCategory(category) {
                return applicationConstants.TRAINING_COLOR_MAP[category];
            }

            function getCompairedStatus(newSearchCriteria) {
                var formattedSearchCriteria = formatSearchCriteria(self.model.searchCriteria);

                //Check trainingProgCategory ANY or equal
                if(formattedSearchCriteria.trainingProgCategory === null){
                    newSearchCriteria.trainingProgCategory = null;
                }else if(formattedSearchCriteria.trainingProgCategory !== newSearchCriteria.trainingProgCategory){
                    return {};
                }

                //Check aircraftModel ANY or equal
                if (formattedSearchCriteria.aircraftModel === null) {
                    newSearchCriteria.aircraftModel = null;
                }else if(formattedSearchCriteria.aircraftModel !== newSearchCriteria.aircraftModel){
                    return {};
                }

                //Check fromDate equal grater than
                if (moment(formattedSearchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT)
                        .isSameOrAfter(moment(newSearchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT))){
                    newSearchCriteria.fromDate = newSearchCriteria.fromDate;
                }else{
                    newSearchCriteria.fromDate = formattedSearchCriteria.fromDate;
                }

                //Check toDate equal lesser than
                if (moment(formattedSearchCriteria.toDate, applicationConstants.SETTINGS.DATE_FORMAT)
                        .isSameOrAfter(moment(newSearchCriteria.toDate, applicationConstants.SETTINGS.DATE_FORMAT))){
                    newSearchCriteria.toDate = newSearchCriteria.toDate;
                }else{
                    newSearchCriteria.toDate = formattedSearchCriteria.toDate;
                }

                return newSearchCriteria;
            }

            function setStartDateTimeForConflicts(conflictsArray) {
                var conflictsStringArray = [];
                angular.forEach(conflictsArray, function (conflictObj) {
                    conflictsStringArray.push(conflictObj.startDateTime)
                });
                return conflictsStringArray;
            }

            function formatSearchCriteria(searchCriteria){
                var noOfDays = getViewDaysBySearchCriteria('D');
                var viewOf = getViewDaysBySearchCriteria('V');
                var trainingProgramRequest = new TrainingProgramRequest();
                trainingProgramRequest.fromDate = searchCriteria.fromDate;
                //set month's 1 data to fromDate
                if (viewOf==='M'){
//                    var mom = moment(searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
//                    var yyyy = mom.year();
//                    var mm = mom.month() + 1;
//                    trainingProgramRequest.fromDate = "01/" + mm + "/" +yyyy;
                	trainingProgramRequest.fromDate = moment(searchCriteria.fromDate, "DD/MM/YYYY").startOf('month').format("DD/MM/YYYY");
                	trainingProgramRequest.toDate = moment(searchCriteria.toDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
                }else{
                	trainingProgramRequest.toDate = moment(searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT)
                    .add(noOfDays,'d')
                    .format(applicationConstants.SETTINGS.DATE_FORMAT);
                }

                if (searchCriteria.trainingCategory=== undefined || searchCriteria.trainingCategory===null){
                    trainingProgramRequest.trainingProgCategory = null
                }else{
                    trainingProgramRequest.trainingProgCategory = $.trim(searchCriteria.trainingCategory.categoryCode);
                }

                if (searchCriteria.trainingLocation === undefined || searchCriteria.trainingLocation === null){
                    trainingProgramRequest.trainingLocation = null
                }else{
                    trainingProgramRequest.trainingLocation = $.trim(searchCriteria.trainingLocation.airPortCode);
                }

                if (trainingProgramRequest.trainingProgCategory===""){
                    trainingProgramRequest.trainingProgCategory = null;
                }

                if (searchCriteria.airCraftType === undefined || searchCriteria.airCraftType===null
                		|| searchCriteria.airCraftType.modelNumber===undefined || searchCriteria.airCraftType.modelNumber===null){
                    trainingProgramRequest.aircraftModel = null;
                }else{
                    trainingProgramRequest.aircraftModel = $.trim(searchCriteria.airCraftType.modelNumber);
                }
                trainingProgramRequest.pageSize = -1;
                trainingProgramRequest.startPosition = 1;

                return trainingProgramRequest
            }

            function applyLocalFilters() {
                var dataMap = ['ANY', null];
                var addAnyOption = function (keyMap, dataMap) {
                    var item = {};
                    for (var i=0;i<keyMap.length;i++){
                        var tem = keyMap[i];
                        item[tem.key] = (dataMap[i] === undefined) ? null : dataMap[i];
                    }
                    return item;
                };

                angular.forEach(localFilters, function (filterObj) {
                    filterObj.list = [];
                    filterObj.list.push(addAnyOption(filterObj.keysMap,dataMap));
                    var sorted = _.sortBy(TrainingPrograms, function(item){
                        return item[filterObj.filterName];
                    });
                    var temp =  _.uniq(sorted, true, function(i){
                        return i[filterObj.filterName];
                    });
                    _.each(temp, function(x){
                        var item = {};
                        for (var i=0;i<filterObj.keysMap.length;i++){
                            var tem = filterObj.keysMap[i];
                            item[tem.key] = x[tem.keyMap];
                        }
                        filterObj.list.push(item);
                    });
                });
            }

            function getViewDaysBySearchCriteria(flag) {
                if (self.model.searchCriteria===null){
                    return "NA";
                }else{
                    var view = 'W',nod=6, send;
                    var fD = moment(self.model.searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var eD = moment(self.model.searchCriteria.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var diffDays = eD.diff(fD, 'days');
                    if (diffDays > 7) {
                        view = 'M';
                        nod = fD.daysInMonth();//get the no of days of the month
                    }else if(diffDays===0){
                        view = 'D';
                        nod = 0;
                    }
                    if(flag==='V'){
                        send = view;
                    }else{
                        send = nod;
                    }
                    return send;
                }
            }

            function trainingProgramButtonConfig(viewType) {
                var config = {
                    NEW_TRAINING:{
                        disable:false
                    },
                    GOTO_PREVIOUS:{
                        disable:false
                    },
                    CURRENT_PERIOD:{
                        disable:true,
                        value:""
                    },
                    GOTO_NEXT:{
                        disable:false
                    },
                    DAY_VIEW:{
                        disable:true
                    },
                    WEEK_VIEW:{
                        disable:true
                    },
                    MONTH_VIEW:{
                        disable:true
                    }
                };
                if(viewType==="M"){
                    var mom = moment(self.model.searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var mm = CommonLogicService.getMonthName(mom.month());
                    var year = mom.year();
                    config.CURRENT_PERIOD.value = mm + " " + year;
                }else if(viewType==="W"){
                    config.CURRENT_PERIOD.value = self.model.searchCriteria.fromDate + " to " + self.model.searchCriteria.toDate;
                }else{
                    if(self.model.searchCriteria===null){
                        config.CURRENT_PERIOD.value = '';
                    }else{
                        config.CURRENT_PERIOD.value = self.model.searchCriteria.fromDate;
                    }

                }

                if(config.CURRENT_PERIOD.value!==""){
                    config.DAY_VIEW.disable = false;
                    config.WEEK_VIEW.disable = false;
                    config.MONTH_VIEW.disable = false;
                }
                return config;
            }

            function getNoOfDaysByView(view, stDate){
                var nod = 1;
                if(view==='W'){
                    nod=7;
                }else if(view==='M'){
                    var stDate = moment(stDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    nod=stDate.daysInMonth();
                }
                return nod;
            }

            function getDateRangeWithOffset(viewType, flagMode, offset) {
                var noOfDays = 0;
                if (viewType==='W'){
                    noOfDays = 6;
                }else if(viewType==='D'){
                    noOfDays = 0;
                }
                var retRange = {
                    fromDate: self.model.searchCriteria.fromDate,
                    toDate: self.model.searchCriteria.toDate,
                    noOfDays: noOfDays
                };
                var stDate = moment(self.model.searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                //var edDate = moment(self.model.searchCriteria.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
                if(viewType==='M'){
                    //if(offset!==0){
                    var MomentDate = moment(retRange.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var mmD = null;
                    if(flagMode===null){
                        mmD = MomentDate.add(0, 'months');
                    }else if(flagMode==='PREVIOUS'){
                        mmD = MomentDate.subtract(1, 'months');
                    }else if(flagMode==='NEXT'){
                        mmD = MomentDate.add(1, 'months');
                    }
                    retRange.fromDate = mmD.startOf('month').format(applicationConstants.SETTINGS.DATE_FORMAT);
                    retRange.toDate = mmD.endOf('month').format(applicationConstants.SETTINGS.DATE_FORMAT);
                    retRange.noOfDays = mmD.daysInMonth();
                   // }
                }else{
                    var newStDate = stDate.add(offset,'d');
                    var nod = noOfDays;
                    retRange.stDate = newStDate.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    retRange.fromDate = newStDate.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    var newFromDate = moment(retRange.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var newEndDate = newFromDate.add(nod, 'd');
                    retRange.toDate = newEndDate.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    retRange.noOfDays = nod;
                }
                return retRange;
            }

            function checkResultsForRange(range) {
                var checkTheGivenDate = function (date) {
                    var groups = _.groupBy(TrainingPrograms, 'startDate'), ret = false;
                    var stDate = moment(date, applicationConstants.SETTINGS.DATE_FORMAT);
                    for (var dataKey in groups) {
                        var dKey = moment(dataKey, applicationConstants.SETTINGS.DATE_FORMAT);
                        if (stDate.diff(dKey) === 0) {
                            ret = true;
                            break;
                        }
                    }
                    return ret;
                };

                var send = false;
                if (checkTheGivenDate(range.fromDate)) {
                    if (checkTheGivenDate(range.toDate)) {
                        send = true;
                    }
                }
                return send;
            }

            function formatCategories(categories) {
                trainingCategories = [];
                var categoryAny = {category:"ANY ", categoryCode:null};
                trainingCategories.push(categoryAny);
                angular.forEach(categories, function (cat, key) {
                    trainingCategories.push({category:cat.categoryCode + " ", categoryCode:cat.categoryCode + " ", showInTrainingAutomation:cat.showInTrainingAutomation});
                });
                return trainingCategories;
            }

            function getProgramsByStartDate(range){
                var tmpPrograms = [];
                var fD = moment(range.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                var eD = moment(range.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
                var diffDays = eD.diff(fD, 'days');
                for (var i=0;i<=diffDays;i++){
                    _.each(_.filter(TrainingPrograms, {'startDate':fD.format(applicationConstants.SETTINGS.DATE_FORMAT)}), function (obj) {
                        tmpPrograms.push(obj);
                    });
                    fD.add(1,'d');
                }
                return tmpPrograms;
            }

            function applyLocalFilter(filter) {
                var filtered = true;
                for(var key in filter){
                    if (filter[key]===""){
                        delete filter[key];
                    }
                }
                if(_.isEmpty(filter)){
                    filtered =false;
                }

                if(filtered){
                    return _.filter(TrainingPrograms, filter);
                }else{
                    return TrainingPrograms;
                }

            }
            applyLocalFilters();
        }
}());
